import { useOpenDetail } from "@web/features/detail/useOpenDetail.ts";

/** Comma-separated artist links for the grid — each opens the detail sheet. */
export function ArtistNamesCell({
  artists,
}: {
  artists: readonly { id: string; name: string | null }[];
}) {
  const openDetail = useOpenDetail();
  const named = artists.filter((a) => a.name);

  if (named.length === 0) {
    return <span className="truncate text-muted">—</span>;
  }

  return (
    <span className="truncate text-muted">
      {named.map((a, i) => (
        <span key={a.id}>
          {i > 0 && ", "}
          <button
            type="button"
            className="max-w-full truncate text-left hover:text-text hover:underline"
            title={a.name ?? undefined}
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              openDetail({ type: "artist", id: a.id, label: a.name ?? "Artist" });
            }}
            onDoubleClick={(e) => e.stopPropagation()}
          >
            {a.name}
          </button>
        </span>
      ))}
    </span>
  );
}
